import Model  from '@/util/models';

export default class Product extends Model { 
    backend = '/survey/jilid/';           
    
    nodes(params={}){
      return this.api.get('/master/node/index', params).then(res => {          
          return res.status == 200 ? res.data : {};
      });
    }

    node(params={}){
      return this.api.get('/master/node/view', params).then(res => {          
          return res.status == 200 ? res.data : {};
      });
    }

    kompetisis(params={}){
      return this.api.get(this.backend+'kompetisis', params).then(res => {          
          return res.status == 200 ? res.data : [];
      });
    }

    importdata(params={}){
      return this.api.get(this.backend+'import-data', params).then(res => {          
          return res.status == 200 ? res.data : [];
      });
    }

    settings(params={}){
      return this.api.get(this.backend + 'settings', params).then(res => {          
        return res.status == 200 ? res.data : [];
      });
    }
}

